import React, { FC, useState } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import OWButton from '../ow_button/OWButton';
import OWRadioGroup from '../ow_radio_group/OWRadioGroup';
import { ExportTemplate } from './ExportColumnsUtils';

interface SaveExportTemplatePopupProps {
	template?: ExportTemplate;
	isAdmin: boolean;
	onSave: (name: string, isPublic: boolean) => Promise<any>;
	onCancel: () => void;
}

const VISIBILITY_OPTIONS = [
	{ label: 'Only me', value: 'false' },
	{ label: 'Your organization', value: 'true' },
];

const SaveExportTemplatePopup: FC<SaveExportTemplatePopupProps> = ({
	template,
	isAdmin,
	onSave,
	onCancel,
}) => {
	const [form] = Form.useForm();
	const [saving, setSaving] = useState(false);
	const isUpdateMode = !!template;

	const handleSubmit = (values: { name: string; isPublic: string }) => {
		setSaving(true);
		onSave(values.name.trim(), values.isPublic === 'true').catch(() => setSaving(false));
	};

	return (
		<Modal
			visible={true}
			title={isUpdateMode ? 'Edit template' : 'Save new template'}
			onCancel={onCancel}
			footer={
				<div className="flex justify-end gap-2">
					<Button onClick={onCancel}>Cancel</Button>
					<OWButton type="primary" htmlType="submit" form="saveExportTemplateForm" loading={saving}>
						Save
					</OWButton>
				</div>
			}
		>
			<Form
				id="saveExportTemplateForm"
				form={form}
				layout="vertical"
				requiredMark={false}
				initialValues={{
					name: isUpdateMode ? template.name : '',
					isPublic: isUpdateMode && template.isPublic ? 'true' : 'false',
				}}
				onFinish={handleSubmit}
			>
				<Form.Item
					name="name"
					label="Name"
					rules={[
						{ required: true, whitespace: true, message: 'Please enter a name for the template' },
					]}
				>
					<Input maxLength={255} placeholder="e.g. Weekly supplier summary" />
				</Form.Item>
				{isAdmin ? (
					<Form.Item name="isPublic" label="Visible to">
						<OWRadioGroup
							items={VISIBILITY_OPTIONS}
							valueAccessor={(item) => item.value}
							renderRecord={(item) => item.label}
						/>
					</Form.Item>
				) : null}
			</Form>
		</Modal>
	);
};

export default SaveExportTemplatePopup;
